import { create } from 'zustand'

// Staff beacons land every few seconds while someone types, so the indicator has
// to outlive one beacon and still disappear soon after the typing stops.
const TYPING_LIFETIME_MS = 5_000

export interface StaffTyping {
  ticketPublicId: string
  staffName: string | null
}

interface StaffTypingActions {
  noteTyping: (typing: StaffTyping) => void
  clearTyping: (ticketPublicId: string) => void
  reset: () => void
}

interface StaffTypingStore {
  typing: StaffTyping | null
  actions: StaffTypingActions
}

// One slot: only one thread is ever open, so only one indicator can be on screen.
export const useStaffTypingStore = create<StaffTypingStore>((set, get) => {
  let expiry: ReturnType<typeof setTimeout> | undefined

  return {
    typing: null,
    actions: {
      noteTyping: (typing) => {
        clearTimeout(expiry)
        expiry = setTimeout(() => set({ typing: null }), TYPING_LIFETIME_MS)
        set({ typing })
      },

      clearTyping: (ticketPublicId) => {
        if (get().typing?.ticketPublicId !== ticketPublicId) return
        clearTimeout(expiry)
        set({ typing: null })
      },

      reset: () => {
        clearTimeout(expiry)
        set({ typing: null })
      },
    },
  }
})

export const useStaffTyping = () => useStaffTypingStore((state) => state.typing)

export const staffTypingActions = () => useStaffTypingStore.getState().actions
